export default __webpack_public_path__ + "static/media/step2.a9648873.png";